/**
 * BUNDLE QUANTITY SELECTOR
 * Usa clases CSS propias (bundle-qty__*) para evitar colisiones
 * con el JS nativo del tema que intercepta .quantity-selector__button
 */

class BundleQuantitySelector extends HTMLElement {
  connectedCallback() {
    // Guard: si el navegador vuelve a disparar connectedCallback sobre el
    // MISMO nodo (por ejemplo porque el drawer del tema lo mueve/reordena
    // en vez de recrearlo), evitamos agregar los listeners por segunda vez.
    // Sin esto, cada re-render duplica los listeners y cada click termina
    // disparando 2x, 4x, 8x peticiones a /cart/update.js.
    if (this._initialized) return
    this._initialized = true

    this._bundleCode = this.dataset.bundleCode
    this._keys       = this._parseKeys(this.dataset.bundleKeys)

    const removeBtn = this.querySelector('.bundle-remove-btn')
    if (removeBtn) {
      removeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this._updateAllItems(0)
      })
    }
  }

  _parseKeys(keysStr) {
    if (!keysStr) return []
    return keysStr.split(',').map(k => k.trim()).filter(Boolean)
  }

  async _updateAllItems(quantity) {
    const lineItem = this.closest('.line-item--bundle')
    if (lineItem) lineItem.classList.add('is-loading')

    try {
      const updates = {}
      this._keys.forEach(key => { updates[key] = quantity })

      const res = await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ updates })
      })

      if (!res.ok) throw new Error('Error actualizando bundle')

      // El bundle fue eliminado: quitamos el bloque visual directamente,
      // sin esperar a que un refresh externo lo haga.
      if (lineItem) lineItem.remove()

      this._refreshCart()

    } catch (err) {
      console.error('[Bundle] Error:', err)
      if (lineItem) lineItem.classList.remove('is-loading')
    }
  }

  _refreshCart() {
    if (window.location.pathname === '/cart') {
      window.location.reload()
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'))
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }))
    }
  }
}

if (!customElements.get('bundle-quantity-selector')) {
  customElements.define('bundle-quantity-selector', BundleQuantitySelector)
}